import BasePage from "../../BasePage";
import React from "react";
import { Card, MenuItem, Skeleton, styled } from "@mui/material";
import { Grid } from "@mui/material";
import {
  ControlledCustomTextField,
  CpfCnpjTextField,
  CustomControlledAutoComplete,
  ZipCodeTextField,
} from "../../../components/inputs";
import { Button } from "../../../components";
import { states } from "../../../utils/constants";
import { useState } from "react";
import CustomControlledSwitch from "../../../components/inputs/CustomControlledSwitch";

const StyledCard = styled(Card)`
  background-color: #dbe4e6;
  height: auto;
  width: auto;
  margin: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  border-radius: 20px;
  box-shadow: 0 0 !important;
  padding: 25px;
`;
const StyledControlledCustomTextField = styled(ControlledCustomTextField)``;

const StyledAtualizarButton = styled(Button)`
  background: linear-gradient(92.97deg, #2f85c2 44.56%, #8ebecd 96.62%);
  height: 40px;
  width: 276px;
  border-radius: 100px;
  padding: 10px 24px 10px 24px;
  margin-top: 20px;
  margin-bottom: 20px;
  @media (max-width: 576px) {
    width: 100%;
  }
`;
const StyledVoltarButton = styled(Button)`
  margin-top: 20px;
  background: #ffffff !important;
  border: 1px solid #2f85c2;
  color: #2f85c2;
  height: 40px;
  width: 276px;
  border-radius: 100px;
  padding: 10px 24px 10px 24px;
  margin-bottom: auto;
  @media (max-width: 576px) {
    width: 100%;
  }
`;

const StyledGrid = styled(Grid)`
  padding: 5px;
`;

const StyledGridContainer = styled(Grid)``;

const ButtonContainer = styled("div")`
  display: flex;
  justify-content: center;
`;
const ButtonContainerLeft = styled("div")`
  display: flex;
  margin-left: 0;
  justify-content: center;
`;

const StyledSkeleton = styled(Skeleton)`
  width: 100%;
  height: 370px;
  margin-bottom: -65px;
  margin-top: -70px;
  border-radius: 20px;
`;

const StyledControlledSwitch = styled(CustomControlledSwitch)`
  & .MuiFormControlLabel-label {
    font-size: 12px;
  }
`;

const StyledForm = styled("form")`
  max-width: 100%;
`;

const StyledTitle = styled("h1")`
  font-family: Oswald;
  font-size: 57px;
  font-weight: 400;
  line-height: 64px;
  letter-spacing: -0.25px;
  text-align: left;
  margin-top: 25px;

  @media (max-width: 576px) {
    margin-left: 20px;
    margin-top: 10px;
    font-size: 43px;
  }
`;
const StyledCardTitle = styled("h1")`
  font-family: Oswald;
  font-size: 32px;
  font-weight: 300;
  line-height: 40px;
  letter-spacing: -0.25px;
  text-align: left;
  margin-top: 0;
  margin-bottom: 5px;

  @media (max-width: 576px) {
    margin-left: 20px;
    margin-top: 10px;
    font-size: 43px;
  }
`;

const FormCriarClientePage = ({
  data,
  loading,
  formProps,
  handleSubmit,
  handleGoBack,
  handleZipCodeBlurred,
  dataMatrizes,
  loadingMatrizes,
}) => {
  const [disableAutoComplete, setDisableAutoComplete] = useState(true);
  const [disableRoteiro, setDisableRoteiro] = useState(true);

  const handleDisableRoteiro = () => {
    formProps.setValue("roteiro", !disableRoteiro);
    setDisableRoteiro(!disableRoteiro);
    if (!disableRoteiro) {
      formProps.setValue("precisao", "");
    } else {
      formProps.setValue("raioPrecisao", "");
      formProps.setValue("pontosRegiao", "");
    }
  };

  if (loading) {
    return (
      <BasePage isLoggedIn={true}>
        <StyledTitle>Novo Cliente</StyledTitle>
        <StyledSkeleton />
      </BasePage>
    );
  }

  return (
    <BasePage>
      <StyledTitle>Novo Cliente</StyledTitle>
      <StyledForm onSubmit={formProps.handleSubmit(handleSubmit)}>
        <StyledCard>
          <StyledCardTitle>Dados Básicos</StyledCardTitle>
          <StyledGridContainer container>
            <StyledGrid item xs={12} sm={12} md={3}>
              <StyledControlledCustomTextField
                formProps={formProps}
                fullWidth
                name="cnpj"
                label="CNPJ"
                type="cnpj"
                InputProps={{
                  inputComponent: CpfCnpjTextField,
                  maxLength: 15,
                }}
              />
            </StyledGrid>
            <StyledGrid item xs={12} sm={12} md={5}>
              <StyledControlledCustomTextField
                formProps={formProps}
                fullWidth
                name="nome"
                label="Nome do cliente"
                inputProps={{ maxLength: 100 }}
              />
            </StyledGrid>
            <StyledGrid item xs={12} sm={12} md={4}>
              <StyledControlledCustomTextField
                formProps={formProps}
                fullWidth
                name="nomeAbreviado"
                label="Nome Abreviado"
                inputProps={{ maxLength: 10 }}
              />
            </StyledGrid>
            <StyledGrid item xs={12} sm={12} md={6}>
              <StyledControlledCustomTextField
                formProps={formProps}
                fullWidth
                name="tipo"
                label="Tipo"
                select
                onChange={(e) => {
                  if (e.target.value === "F") {
                    setDisableAutoComplete(false);
                  }
                  if (e.target.value === "M") {
                    formProps.clearErrors("idMatriz");

                    setDisableAutoComplete(true);
                  }
                }}
              >
                <MenuItem key={"M"} value={"M"}>
                  Matriz
                </MenuItem>
                <MenuItem key={"F"} value={"F"}>
                  Filial
                </MenuItem>
              </StyledControlledCustomTextField>
            </StyledGrid>

            <StyledGrid item xs={12} sm={12} md={6}>
              <StyledControlledCustomTextField
                formProps={formProps}
                fullWidth
                name="situacao"
                label="Situação"
                select
              >
                <MenuItem key={"A"} value={"A"}>
                  Ativo
                </MenuItem>
                <MenuItem key={"I"} value={"I"}>
                  Inativo
                </MenuItem>
              </StyledControlledCustomTextField>
            </StyledGrid>
            {!disableAutoComplete && (
              <StyledGrid item xs={12} sm={12} md={6}>
                <CustomControlledAutoComplete
                  formProps={formProps}
                  fullWidth
                  name="idMatriz"
                  label="Matriz"
                  labelField={"nome"}
                  idField={"id"}
                  loading={loadingMatrizes.toString()}
                  domain={dataMatrizes}
                  disabled={disableAutoComplete}
                />
              </StyledGrid>
            )}
          </StyledGridContainer>
        </StyledCard>
        <StyledCard>
          <StyledCardTitle>Permissões do Usuário Final</StyledCardTitle>
          <StyledGridContainer container>
            <StyledGrid item xs={12} sm={12} md={4}>
              <StyledControlledSwitch
                formProps={formProps}
                fullWidth
                name="exibeMapaProUsuarioFinal"
                label="Habilitar Mapa para Usuário Final?"
              ></StyledControlledSwitch>
            </StyledGrid>
            <StyledGrid item xs={12} sm={12} md={4}>
              <StyledControlledSwitch
                formProps={formProps}
                fullWidth
                name="exibeOpcaoPercursoOperacaoDiaria"
                label="Habilitar Percurso do Mapa na Operação Diária?"
              ></StyledControlledSwitch>
            </StyledGrid>
            <StyledGrid item xs={12} sm={12} md={4}>
              <StyledControlledSwitch
                formProps={formProps}
                fullWidth
                name="exibeOpcaoEfetivoOperacaoDiaria"
                label="Habilitar Efetivo do Mapa na Operação Diária?"
              ></StyledControlledSwitch>
            </StyledGrid>
          </StyledGridContainer>
        </StyledCard>
        <StyledCard>
          <StyledCardTitle>Endereço</StyledCardTitle>
          <StyledGridContainer container>
            <StyledGrid item xs={12} sm={12} md={4}>
              <StyledControlledCustomTextField
                label="CEP"
                name={"cep"}
                formProps={formProps}
                onBlur={() => handleZipCodeBlurred(formProps.getValues("cep"))}
                InputProps={{
                  inputComponent: ZipCodeTextField,
                }}
              />
            </StyledGrid>
            <StyledGrid item xs={12} sm={12} md={6}>
              <StyledControlledCustomTextField
                label="Logradouro"
                name={"logradouro"}
                formProps={formProps}
                margin={"none"}
                inputProps={{ maxLength: 40 }}
              />
            </StyledGrid>
            <StyledGrid item xs={12} sm={12} md={2}>
              <StyledControlledCustomTextField
                label="Número"
                name={"numeroLogradouro"}
                formProps={formProps}
                margin={"none"}
                inputProps={{ maxLength: 7 }}
              />
            </StyledGrid>
            <StyledGrid item xs={12} sm={12} md={4}>
              <StyledControlledCustomTextField
                label="Complemento"
                name={"complemento"}
                formProps={formProps}
                margin={"none"}
                inputProps={{ maxLength: 30 }}
              />
            </StyledGrid>
            <StyledGrid item xs={12} sm={12} md={3}>
              <StyledControlledCustomTextField
                label="Bairro"
                name={"bairro"}
                formProps={formProps}
                margin={"none"}
                inputProps={{ maxLength: 40 }}
              />
            </StyledGrid>
            <StyledGrid item xs={12} sm={12} md={3}>
              <StyledControlledCustomTextField
                label="Cidade"
                name={"municipio"}
                formProps={formProps}
                margin={"none"}
                flex={3}
                inputProps={{ maxLength: 60 }}
              />
            </StyledGrid>
            <StyledGrid item xs={12} sm={12} md={2}>
              <StyledControlledCustomTextField
                label="UF"
                name={"uf"}
                formProps={formProps}
                margin={"none"}
                select
              >
                {states.map((state) => (
                  <MenuItem
                    className={"select-submenu-item"}
                    key={state}
                    value={state}
                  >
                    {state}
                  </MenuItem>
                ))}
              </StyledControlledCustomTextField>
            </StyledGrid>
          </StyledGridContainer>
        </StyledCard>
        <StyledCard>
          <StyledCardTitle>Roteiro</StyledCardTitle>
          <StyledGridContainer container>
            <StyledGrid item xs={12} sm={12} md={2}>
              <StyledControlledCustomTextField
                formProps={formProps}
                fullWidth
                name="lote"
                label="Lote"
                type={"number"}
                inputProps={{ min: 0, max: 32767 }}
              />
            </StyledGrid>

            <StyledGrid item xs={12} sm={12} md={4}>
              <StyledControlledCustomTextField
                formProps={formProps}
                fullWidth
                name="latitude"
                label="Latitude"
                inputProps={{ maxLength: 15 }}
              ></StyledControlledCustomTextField>
            </StyledGrid>
            <StyledGrid item xs={12} sm={12} md={4}>
              <StyledControlledCustomTextField
                formProps={formProps}
                fullWidth
                name="longitude"
                label="Longitude"
                inputProps={{ maxLength: 15 }}
              ></StyledControlledCustomTextField>
            </StyledGrid>
            <StyledGrid item xs={12} sm={12} md={2}>
              <StyledControlledSwitch
                onChange={handleDisableRoteiro}
                formProps={formProps}
                fullWidth
                name="roteiro"
                label="Possui Roteiro?"
              ></StyledControlledSwitch>
            </StyledGrid>
            <StyledGrid item xs={12} sm={12} md={4}>
              <StyledControlledCustomTextField
                formProps={formProps}
                fullWidth
                name="pontosRegiao"
                label="Pontos na região"
                disabled={!disableRoteiro}
                type="number"
                inputProps={{ min: 1, max: 32767 }}
              ></StyledControlledCustomTextField>
            </StyledGrid>
            <StyledGrid item xs={12} sm={12} md={4}>
              <StyledControlledCustomTextField
                formProps={formProps}
                fullWidth
                name="raioPrecisao"
                label="Raio de precisão"
                disabled={!disableRoteiro}
                type="number"
                inputProps={{ min: 1, max: 32767 }}
              ></StyledControlledCustomTextField>
            </StyledGrid>
            <StyledGrid item xs={12} sm={12} md={4}>
              <StyledControlledCustomTextField
                formProps={formProps}
                fullWidth
                name="precisao"
                label="Precisão"
                disabled={disableRoteiro}
                type="number"
                inputProps={{ min: 1, max: 32767 }}
              ></StyledControlledCustomTextField>
            </StyledGrid>
          </StyledGridContainer>
        </StyledCard>
        <Grid justifyContent="center" container>
          <Grid item xs={12} sm={12} md={6}>
            <ButtonContainer>
              <StyledVoltarButton onClick={handleGoBack}>
                Voltar
              </StyledVoltarButton>
            </ButtonContainer>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <ButtonContainerLeft>
              <StyledAtualizarButton type={"submit"} loading={loading}>
                Criar
              </StyledAtualizarButton>
            </ButtonContainerLeft>
          </Grid>
        </Grid>
      </StyledForm>
    </BasePage>
  );
};

export default FormCriarClientePage;
